import React from "react";
import { motion } from "framer-motion";

const IMAGES = [
  {
    src:
      "https://images.unsplash.com/photo-1770644426789-4fe022415ab7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxzcGljZSUyMGZhcm0lMjBncmVlbmVyeXxlbnwwfHx8fDE3ODU0OTM3NTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Cardamom plantation greenery",
    span: "row-span-2",
    ratio: "aspect-[4/6]",
  },
  {
    src:
      "https://images.unsplash.com/photo-1701166627787-12d9fdd437cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxncmVlbiUyMGNhcmRhbW9tJTIwcG9kc3xlbnwwfHx8fDE3ODU0OTM3NTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Green cardamom pods pile",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    src: "https://images.pexels.com/photos/19227962/pexels-photo-19227962.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Vibrant spices market",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    src:
      "https://images.unsplash.com/photo-1763558049571-a6d12a85472e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxncmVlbiUyMGNhcmRhbW9tJTIwcG9kc3xlbnwwfHx8fDE3ODU0OTM3NTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Cardamom pods held in hand",
    span: "row-span-2",
    ratio: "aspect-[4/6]",
  },
  {
    src:
      "https://images.unsplash.com/photo-1716540103530-cc33cdd20cde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmb29kJTIwcGFja2FnaW5nfGVufDB8fHx8MTc4NTQ5Mzc2Mnww&ixlib=rb-4.1.0&q=85",
    alt: "Luxury packaging",
    span: "",
    ratio: "aspect-[16/10]",
  },
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-cream py-28 md:py-40 border-t border-charcoal/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-end justify-between gap-8 flex-wrap mb-14 md:mb-20">
          <div>
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
              className="font-sans text-[11px] uppercase tracking-[0.32em] text-charcoal/60 mb-6 flex items-center gap-3"
            >
              <span className="text-gold">§</span> Field Notes
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, ease: [0.65, 0, 0.35, 1] }}
              className="font-serif font-light text-5xl md:text-6xl lg:text-7xl text-charcoal leading-[0.98]"
            >
              A quiet <span className="italic text-forest">portrait</span> of
              the trade.
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="max-w-[38ch] font-sans text-charcoal/65 leading-relaxed text-base md:text-[17px]"
          >
            From the estate to the export dock — moments from a working year.
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 grid-rows-[auto] gap-4 md:gap-6 auto-rows-[minmax(200px,auto)]">
          {IMAGES.map((img, i) => (
            <motion.figure
              key={img.src}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.08,
                ease: [0.65, 0, 0.35, 1],
              }}
              className={`group relative overflow-hidden rounded-sm bg-forest/10 ${img.span}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className={`h-full w-full object-cover ${img.ratio} transition-transform duration-1000 ease-out group-hover:scale-[1.08]`}
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-forestDeep/85 via-forestDeep/25 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-700" />
              <figcaption className="absolute left-4 bottom-4 right-4 flex items-end justify-between font-sans text-[11px] uppercase tracking-[0.28em] text-cream drop-shadow-[0_1px_3px_rgba(0,0,0,0.55)]">
                <span>{img.alt}</span>
                <span className="font-serif italic normal-case tracking-normal text-gold text-base drop-shadow-[0_1px_3px_rgba(0,0,0,0.55)]">
                  0{i + 1}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
